
define('app/users/pwreset/activate/pwActMain',[
	'domReady',
	'app/users/pwreset/activate/pwActApp',
	'app/common/setup',
	'unknown/unknownSetup'
], function(domReady, PwActApp, Setup, UnknownSetup){
	domReady(function () {
		Setup.initialize();
		PwActApp.initialize();
		UnknownSetup.initialize();
    });
});